"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyxTransactionsQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 *  @hidden
 */
function createPolyxTransactionFilters({ identityId, addresses }) {
    const args = ['$size: Int, $start: Int'];
    const fromIdFilters = [];
    const toIdFilters = [];
    const variables = {};
    if (identityId) {
        variables.identityId = identityId;
        args.push('$identityId: String!');
        fromIdFilters.push('identityId: { equalTo: $identityId }');
        toIdFilters.push('toId: { equalTo: $identityId }');
    }
    if (addresses === null || addresses === void 0 ? void 0 : addresses.length) {
        variables.addresses = addresses;
        args.push('$addresses: [String!]!');
        fromIdFilters.push('address: { in: $addresses }');
        toIdFilters.push('toAddress: { in: $addresses }');
    }
    return {
        args: `(${args.join()})`,
        filter: fromIdFilters.length && toIdFilters.length
            ? `filter: { or: [ { ${fromIdFilters.join()} }, { ${toIdFilters.join()} } ] }`
            : '',
        variables,
    };
}
/**
 * @hidden
 *
 * Get POLYX transactions where an Account or an Identity is involved
 */
function polyxTransactionsQuery(paddedIds, filters, size, start) {
    const { args, filter, variables } = createPolyxTransactionFilters(filters);
    const orderBy = paddedIds
        ? `${types_1.PolyxTransactionsOrderBy.CreatedBlockIdAsc}`
        : `${types_1.PolyxTransactionsOrderBy.CreatedAtAsc}, ${types_1.PolyxTransactionsOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query PolyxTransactionsQuery
      ${args}
     {
      polyxTransactions(
        ${filter}
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        nodes {
          id
          identityId
          address
          toId
          toAddress
          amount
          type
          extrinsic {
            extrinsicIdx
          }
          callId
          eventId
          moduleId
          eventIdx
          memo
          datetime
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, variables), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.polyxTransactionsQuery = polyxTransactionsQuery;
//# sourceMappingURL=polyxTransactions.js.map